import { jsx as t } from "react/jsx-runtime";
import { AddToCartButton as i } from "./AddToCartButton.js";
import u from "./QuantitySelector.js";
const m = ({
  addToCartAction: r,
  quantitySelectorAction: o,
  productInCart: d,
  layout: n
}) => /* @__PURE__ */ t("div", { id: "product-card-button", children: d ? /* @__PURE__ */ t(u, { ...o, layout: n }) : /* @__PURE__ */ t(i, { handleAddToCart: r }) });
export {
  m as ProductCardButton
};
